import { render, staticRenderFns } from "./PermissionsCard.vue?vue&type=template&id=78250ab2&scoped=true"
import script from "./PermissionsCard.vue?vue&type=script&lang=js"
export * from "./PermissionsCard.vue?vue&type=script&lang=js"
import style0 from "./PermissionsCard.vue?vue&type=style&index=0&id=78250ab2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78250ab2",
  null
  
)

export default component.exports